import { DeleteFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import { Checkbox, Image, Modal } from 'antd';
import NoImage from 'assets/No_Image_Available.jpg';
import { useEventUpdateStatus } from 'features/events/use-cases/event-update-status';

const EventGalleryImgView = ({ data, refetch }: { data: any, refetch: any }) => {

    const handleCheckboxChange = (id: string) => {
        const formData = {
            id: id,
            status: true,
            flag: "Gallery_Set_Default"
        }
        mutate(formData);
        setTimeout(() => {
            refetch();
        }, 1000)
    };


    const { mutate } = useEventUpdateStatus();

    const { confirm } = Modal;

    const showDeleteConfirm = (id: string, is_setdefault: boolean, status: string) => {
        confirm({
            title: 'Are you sure you want to delete this Image?',
            icon: <ExclamationCircleOutlined />,
            okText: 'Yes',
            okType: 'danger',
            cancelText: 'No',
            onOk() {
                handleDeleteImg(id, is_setdefault, status);
            },
        });
    };

    const handleDeleteImg = (id: string, is_setdefault: boolean, status: string) => {
        const deletedFormData = {
            id: id,
            status: is_setdefault,
            flag: status
        }
        mutate(deletedFormData,);
        setTimeout(() => {
            refetch();
        }, 1000)
    }

    return (
        <>
            <div className='glry_list'>
                {data.items !== null && data.items.length > 0 ?
                    data.items.map((curItem: { img_url: string; is_setdefault: boolean, id: string, media_type: number }) => (
                        <div key={curItem.id} className='glery_bx'>

                            {curItem.media_type === 2 || /\.(mp4|webm|mov)(\?.*)?$/i.test(curItem.img_url || '') ? (
                                /* Video Player for Type 2 */
                                <div
                                    className="video_container"
                                    style={{
                                        position: "relative",
                                        background: "#000",
                                        borderRadius: "6px",
                                        height: "200px",
                                        overflow: "hidden",
                                    }}
                                >
                                    <video
                                        key={curItem.img_url}
                                        autoPlay
                                        muted
                                        loop
                                        playsInline
                                        preload="metadata"
                                        controls   // 👈 temporarily enable for debugging
                                        style={{
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    >
                                        <source src={encodeURI(curItem.img_url)} type="video/mp4" />
                                        Your browser does not support the video tag.
                                    </video>
                                </div>

                            ) : (
                                /* Image Player for Type 1 */
                                <Image
                                    style={{ borderRadius: '6px', width: '100%', height: '200px', objectFit: 'cover' }}
                                    src={curItem.img_url}
                                    placeholder={true}
                                    preview={true}
                                />
                            )}

                            <div className='img_edit'>
                                <Checkbox
                                    checked={curItem.is_setdefault}
                                    onChange={() => handleCheckboxChange(curItem.id)}
                                >
                                    Set Default
                                </Checkbox>

                                <div className='icon_bx'>
                                    <DeleteFilled onClick={() => showDeleteConfirm(curItem.id, curItem.is_setdefault, "Gallery_Set_Delete")} />
                                </div>
                            </div>
                        </div>
                    ))
                    :
                    <div className="no_data_box">
                        <img src={NoImage} height={"300px"} alt="No Content" />
                    </div>
                }
            </div>
        </>

    )
}

export default EventGalleryImgView;
